import Axios from "axios";

const baseURLci = process.env.CI_APPS;
const successStatusCode = 200;

export default {
    searchMaster(params) {
        return Axios.get(`${process.env.BARRAMUNDI}inventory/search-master`, {
            params: {
                query: params.query,
                page: params.page,
                per_page: params.per_page
            }
        }).then(res => {
            if (
                res.data &&
                res.data.response &&
                res.data.response.message.code == successStatusCode
            ) {
                return res.data.response;
            }
            return [];
        });
    },
    getItems(params) {
        // Send item ID to get a details of an item inventory
        return Axios.get(`${baseURLci}ajax/item/filter_items`, { params }).then(
            response => response.data
        );
    },
    async getItemsWithSearch(params) {
        let res = await Axios.get(`${process.env.BARRAMUNDI}inventory/search`, {
            params
        });
        if (res && res.data && res.data.response) {
            return res.data.response;
        } else {
            return [];
        }
    },
    getItemActionOption(itemId, actionsKey) {
        let params = {
            item_id: itemId,
            actions_key: actionsKey
        };
        return Axios.get(`${baseURLci}ajax/item/get_reminder_action_options`, {
            params
        }).then(response => response.data);
    },
    async getInventoryDueOptions() {
        let res = await Axios.get(`${process.env.BARRAMUNDI}inventory/due`);

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async getFees(params) {
        let res = await Axios.get(`${process.env.BARRAMUNDI}inventory/fees`, {
            params
        });

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async post(params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory`,
            params
        );

        if (res.data && res.data.response && res.data.response.resources) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async getItemDetails(itemId, params = {}) {
        params = Object.assign(
            {
                // default params
                encoded: false,
                with_item_dosage: true
            },
            params // applied params
        );

        let res = await Axios.get(
            `${process.env.BARRAMUNDI}inventory/${itemId}`,
            {
                params: params
            }
        );

        if (
            res.data &&
            res.data.response &&
            res.data.response.message.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else if (
            res.data &&
            res.data.response &&
            (res.data.response.no_access || res.data.response.switch_business)
        ) {
            // to return the data if failed and need to switch business
            return res.data.response;
        } else {
            return null;
        }
    },
    async getItemDosage(itemId) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}inventory/${itemId}/dosage`
        );

        if (res.data && res.data.response && res.data.response.resource) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    async getCategories(isWithItemClass = 1, withCategories = 1) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}inventory/category-by-type`,
            {
                params: {
                    with_item_class: isWithItemClass,
                    with_categories: withCategories
                }
            }
        );

        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async getMasterUOM(params = {}) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}reference/master-uom`,
            { params }
        );
        if (
            res.data &&
            res.data.response &&
            res.data.response.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async getFeesOptions(itemId, params) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}inventory/${itemId}/fees`,
            { params }
        );
        if (
            res.data &&
            res.data.response &&
            res.data.response.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async getRouteOptions() {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}reference/master-vaccination-route`
        );
        if (
            res.data &&
            res.data.response &&
            res.data.response.message.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async getLocationOptions() {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}reference/master-vaccination-location`
        );
        if (
            res.data &&
            res.data.response &&
            res.data.response.message.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async getDuesOptions() {
        let res = await Axios.get(`${process.env.BARRAMUNDI}inventory/due`);
        if (
            res.data &&
            res.data.response &&
            res.data.response.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return [];
        }
    },
    async updateItem(itemId, details) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}inventory/${itemId}`,
            details
        );
        if (
            res.data &&
            res.data.response &&
            res.data.response.message.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return null;
        }
    },
    async newItem(params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory`,
            params
        );

        if (
            res.data &&
            res.data.response &&
            res.data.response.message.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return null;
        }
    },
    async mergeItem(params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory/merge`,
            params
        );

        if (
            res.data &&
            res.data.response &&
            res.data.response.code == successStatusCode &&
            res.data.response.resources
        ) {
            return res.data.response.resources;
        } else {
            return null;
        }
    },
    deleteItem(itemId) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}inventory/${itemId}`
        ).then(response => response.data);
    },
    checkDeleteItem(itemId) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/${itemId}/check-delete`
        ).then(res => {
            if (
                res.data &&
                res.data.response &&
                res.data.response.code == successStatusCode
            ) {
                return res.data.response;
            }
            return null;
        });
    },
    getTransactions(itemId, page) {
        return Axios.get(`${process.env.BARRAMUNDI}inventory/sales/${itemId}`, {
            params: { page }
        }).then(res => {
            if (
                res.data &&
                res.data.response &&
                res.data.response.message.code == successStatusCode &&
                res.data.response.resources
            ) {
                return res.data.response;
            }
            return [];
        });
    },
    /**
     * @method bulkUpdateOptions
     * @description this api is used to
     * 1. retrieve items/categories for bulk update
     * 2. retrieve list of bundles based on item/categories
     * @returns {Object}
     */
    bulkUpdateOptions(params) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/bulk-update-option`,
            { params }
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    /**
     * @method getSelectedItemDetails
     * @description this api is used to retrieve the fee_price from uses
     * @param {String} itemId
     * @param {Object} params {"item_id":"a585b00c-afac-44","module":"bundle"}
     * @returns
     */
    getSelectedItemDetails(params) {
        return Axios.get(`${process.env.BARRAMUNDI}inventory/filterItems`, {
            params
        }).then(res => {
            if (
                res.data &&
                res.data.response &&
                res.data.response.message.code == successStatusCode &&
                res.data.response.resource
            ) {
                return res.data.response.resource;
            }
            return [];
        });
    },
    getAlerts(params) {
        return Axios.get(`${process.env.BARRAMUNDI}inventory/alert`, {
            params
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    getCategoriesByType(params) {
        return Axios.get(`${process.env.BARRAMUNDI}inventory/category`, {
            params: params
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getAllItems(params) {
        return Axios.get(`${process.env.BARRAMUNDI}inventory`, {
            params: params
        }).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    postBulkUpdate(params) {
        return Axios.post(
            `${process.env.BARRAMUNDI}inventory/bulk-update`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    async getIntergratedItemsWithSearch(params) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}inventory/filter-integrated-catalog`,
            {
                params
            }
        );
        if (res && res.data && res.data.response) {
            return res.data.response;
        } else {
            return [];
        }
    }
};
